import React from "react";

/**
 * Horizontal (desktop) / compact (mobile) progress indicator for the
 * multi-step bill-of-sale wizard.
 */
export default function ProgressSteps({ steps, currentStep }) {
  return (
    <div className="w-full">
      {/* Mobile: simple bar + label */}
      <div className="mb-4 sm:hidden">
        <div className="flex items-center justify-between text-xs text-navy-light">
          <span className="font-semibold text-sky-dark">
            مرحله {currentStep} از {steps.length}
          </span>
          <span>{steps[currentStep - 1]?.title}</span>
        </div>
        <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-gray-200">
          <div
            className="h-full rounded-full bg-sky transition-all duration-500"
            style={{ width: `${(currentStep / steps.length) * 100}%` }}
          />
        </div>
      </div>

      {/* Desktop: full step row */}
      <ol className="hidden items-start sm:flex">
        {steps.map((step, idx) => {
          const stepNumber = idx + 1;
          const isActive = stepNumber === currentStep;
          const isDone = stepNumber < currentStep;
          return (
            <li key={step.title} className="flex flex-1 flex-col items-center">
              <div className="flex w-full items-center">
                <div className="flex-1">
                  {idx !== 0 && (
                    <div
                      className={`h-0.5 w-full transition-colors ${
                        isDone || isActive ? "bg-sky" : "bg-gray-200"
                      }`}
                    />
                  )}
                </div>
                <div
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 text-sm font-bold transition-colors ${
                    isDone
                      ? "border-sky bg-sky text-white"
                      : isActive
                      ? "border-sky bg-white text-sky-dark"
                      : "border-gray-200 bg-white text-gray-400"
                  }`}
                >
                  {isDone ? "✓" : stepNumber}
                </div>
                <div className="flex-1">
                  {idx !== steps.length - 1 && (
                    <div
                      className={`h-0.5 w-full transition-colors ${
                        isDone ? "bg-sky" : "bg-gray-200"
                      }`}
                    />
                  )}
                </div>
              </div>
              <span
                className={`mt-2 max-w-[6.5rem] text-center text-xs font-medium leading-snug ${
                  isActive ? "text-sky-dark" : "text-gray-400"
                }`}
              >
                {step.title}
              </span>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
